var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFileUpload(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 63,
    height: 51,
    viewBox: "0 0 63 51",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M56.5 6.75H31.5L25.25 0.5H6.5C3.0625 0.5 0.28125 3.3125 0.28125 6.75L0.25 44.25C0.25 47.6875 3.0625 50.5 6.5 50.5H56.5C59.9375 50.5 62.75 47.6875 62.75 44.25V13C62.75 9.5625 59.9375 6.75 56.5 6.75ZM56.5 44.25H6.5V13H56.5V44.25ZM19 28.6562L23.4063 33.0625L28.375 28.125V41.125H34.625V28.125L39.5938 33.0938L44 28.6562L31.5313 16.125L19 28.6562Z",
    fill: "#827F7F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFileUpload);
export default __webpack_public_path__ + "static/media/fileUpload.8f44d801c271127db478c1d76c6629fb.svg";
export { ForwardRef as ReactComponent };